var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          staticClass: "dialog",
          attrs: {
            title: "银行账号变更",
            visible: _vm.dialogVisible,
            "close-on-click-modal": false,
            "close-on-press-escape": false,
            width: "50%",
            center: "",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
            close: _vm.onHandleClose,
          },
        },
        [
          _c(
            "div",
            { staticClass: "contents" },
            [
              _c(
                "el-form",
                {
                  directives: [
                    {
                      name: "loading",
                      rawName: "v-loading",
                      value: _vm.dialogLoading,
                      expression: "dialogLoading",
                    },
                  ],
                  ref: "refCityForm",
                  staticClass: "demo-cityForm",
                  attrs: {
                    "label-width": "200px",
                    model: _vm.cityForm,
                    rules: _vm.cityRules,
                  },
                },
                [
                  _c("div", { staticClass: "font-15 font-weight mb-10" }, [
                    _vm._v("供应商: " + _vm._s(_vm.title)),
                  ]),
                  [
                    _c(
                      "el-form-item",
                      { attrs: { label: "提现银行卡", prop: "card_code" } },
                      [
                        _c(
                          "div",
                          [
                            _c("el-input", {
                              attrs: {
                                placeholder: "请输入提现银行卡",
                                clearable: "",
                              },
                              model: {
                                value: _vm.cityForm.card_code,
                                callback: function ($$v) {
                                  _vm.$set(_vm.cityForm, "card_code", $$v)
                                },
                                expression: "cityForm.card_code",
                              },
                            }),
                          ],
                          1
                        ),
                      ]
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: "所属银行", prop: "bank_code" } },
                      [
                        _c(
                          "div",
                          [
                            _c(
                              "el-select",
                              {
                                attrs: {
                                  clearable: "",
                                  filterable: "",
                                  placeholder: "选择所属银行",
                                },
                                on: {
                                  change: function ($event) {
                                    _vm.depositList = []
                                    _vm.cityForm.bank_deposit = ""
                                  },
                                },
                                model: {
                                  value: _vm.cityForm.bank_code,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.cityForm, "bank_code", $$v)
                                  },
                                  expression: "cityForm.bank_code",
                                },
                              },
                              _vm._l(_vm.bankList, function (item) {
                                return _c("el-option", {
                                  key: item.bank_code,
                                  attrs: {
                                    label: item.bank_name,
                                    value: item.bank_code,
                                  },
                                  nativeOn: {
                                    click: function ($event) {
                                      _vm.cityForm.bank_name = item.bank_name
                                    },
                                  },
                                })
                              }),
                              1
                            ),
                          ],
                          1
                        ),
                      ]
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: "开户行", prop: "bank_deposit" } },
                      [
                        _c(
                          "div",
                          [
                            _c(
                              "el-select",
                              {
                                attrs: {
                                  "remote-method": _vm.ajaxGetBranchList,
                                  loading: _vm.depositLoading,
                                  clearable: "",
                                  filterable: "",
                                  remote: "",
                                  placeholder: "选择开户行",
                                },
                                model: {
                                  value: _vm.cityForm.bank_deposit,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.cityForm, "bank_deposit", $$v)
                                  },
                                  expression: "cityForm.bank_deposit",
                                },
                              },
                              _vm._l(_vm.depositList, function (item) {
                                return _c("el-option", {
                                  key: item.code,
                                  attrs: {
                                    label: item.branch_name,
                                    value: item.branch_name,
                                  },
                                  nativeOn: {
                                    click: function ($event) {
                                      _vm.cityForm.deposit_code = item.code
                                    },
                                  },
                                })
                              }),
                              1
                            ),
                          ],
                          1
                        ),
                      ]
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: "持卡人姓名", prop: "username" } },
                      [
                        _c(
                          "div",
                          [
                            _c("el-input", {
                              attrs: {
                                placeholder: "请输入持卡人姓名",
                                clearable: "",
                              },
                              model: {
                                value: _vm.cityForm.username,
                                callback: function ($$v) {
                                  _vm.$set(_vm.cityForm, "username", $$v)
                                },
                                expression: "cityForm.username",
                              },
                            }),
                          ],
                          1
                        ),
                      ]
                    ),
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: "持卡人身份证国徽页图片",
                          prop: "idcard_a",
                        },
                      },
                      [
                        _c(
                          "el-upload",
                          {
                            directives: [
                              {
                                name: "loading",
                                rawName: "v-loading",
                                value: _vm.uploadLoading,
                                expression: "uploadLoading",
                              },
                            ],
                            class: {
                              hide: _vm.idcard_a.length || !_vm.idcard_a,
                            },
                            attrs: {
                              action: "#",
                              "on-preview": _vm.onHandlePictureCardPreview,
                              "file-list": _vm.idcard_a,
                              "list-type": "picture-card",
                              "http-request": (data) =>
                                _vm.onHandleUploadFile(data, "idcard_a"),
                              "before-remove": () =>
                                _vm.onHandleDeleteFile("idcard_a"),
                              limit: 1,
                            },
                          },
                          [
                            _c("i", {
                              staticClass: "el-icon-plus",
                              attrs: { slot: "trigger" },
                              slot: "trigger",
                            }),
                          ]
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: "持卡人身份证人像页图片",
                          prop: "idcard_b",
                        },
                      },
                      [
                        _c(
                          "el-upload",
                          {
                            directives: [
                              {
                                name: "loading",
                                rawName: "v-loading",
                                value: _vm.uploadLoading,
                                expression: "uploadLoading",
                              },
                            ],
                            class: {
                              hide: _vm.idcard_b.length || !_vm.idcard_b,
                            },
                            attrs: {
                              action: "#",
                              "on-preview": _vm.onHandlePictureCardPreview,
                              "file-list": _vm.idcard_b,
                              "list-type": "picture-card",
                              "http-request": (data) =>
                                _vm.onHandleUploadFile(data, "idcard_b"),
                              "before-remove": () =>
                                _vm.onHandleDeleteFile("idcard_b"),
                              limit: 1,
                            },
                          },
                          [
                            _c("i", {
                              staticClass: "el-icon-plus",
                              attrs: { slot: "trigger" },
                              slot: "trigger",
                            }),
                          ]
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        attrs: { label: "持卡人身份证号", prop: "idcard_code" },
                      },
                      [
                        _c(
                          "div",
                          [
                            _c("el-input", {
                              attrs: { placeholder: "请输入持卡人身份证号" },
                              model: {
                                value: _vm.cityForm.idcard_code,
                                callback: function ($$v) {
                                  _vm.$set(_vm.cityForm, "idcard_code", $$v)
                                },
                                expression: "cityForm.idcard_code",
                              },
                            }),
                          ],
                          1
                        ),
                      ]
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: "预留电话", prop: "bank_mobile" } },
                      [
                        _c(
                          "div",
                          [
                            _c("el-input", {
                              attrs: { placeholder: "请输入预留电话" },
                              model: {
                                value: _vm.cityForm.bank_mobile,
                                callback: function ($$v) {
                                  _vm.$set(_vm.cityForm, "bank_mobile", $$v)
                                },
                                expression: "cityForm.bank_mobile",
                              },
                            }),
                          ],
                          1
                        ),
                      ]
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: "变更协议", prop: "pact_url" } },
                      [
                        _c(
                          "el-upload",
                          {
                            directives: [
                              {
                                name: "loading",
                                rawName: "v-loading",
                                value: _vm.uploadLoading,
                                expression: "uploadLoading",
                              },
                            ],
                            class: {
                              hide: _vm.pact_url.length || !_vm.pact_url,
                            },
                            attrs: {
                              action: "#",
                              "on-preview": _vm.onHandlePictureCardPreview,
                              "file-list": _vm.pact_url,
                              "list-type": "picture-card",
                              "http-request": (data) =>
                                _vm.onHandleUploadFile(data, "pact_url"),
                              "before-remove": () =>
                                _vm.onHandleDeleteFile("pact_url"),
                              limit: 1,
                            },
                          },
                          [
                            _c("i", {
                              staticClass: "el-icon-plus",
                              attrs: { slot: "trigger" },
                              slot: "trigger",
                            }),
                          ]
                        ),
                      ],
                      1
                    ),
                  ],
                ],
                2
              ),
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c("el-button", { on: { click: _vm.onHandleClose } }, [
                _vm._v("取 消"),
              ]),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", loading: _vm.submitLoading },
                  on: { click: _vm.onHandleSubmit },
                },
                [_vm._v("提交申请")]
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }